import React from "react";

const IncrementIcon: React.FC<{
  className?: string;
  fillColor?: string;
  strokeColor?: string;
}> = ({
  className,
  fillColor = "#EEEEEE", // Default fill color
  strokeColor = "black", // Default stroke color
}) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="8.57576" cy="9" rx="8.52522" ry="8.05707" fill={fillColor} />
      <path
        d="M8.38623 6.67239V11.6857"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.73413 9.17908H11.0387"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IncrementIcon;
